import { Role } from '../roles/index.js';
import { LegalDocument } from './legal-document.enum.js';
/**
 * The terms of use come in one flavour per kind of Person (#1824). A Person
 * accepts the flavour of its role, once per Person: an Account that is staff in
 * one office and a patient in another accepts both, one in each office.
 */
export var TermsOfUseFlavour;
(function (TermsOfUseFlavour) {
    TermsOfUseFlavour["OFFICE_USER"] = "OFFICE_USER";
    TermsOfUseFlavour["PATIENT"] = "PATIENT";
    TermsOfUseFlavour["PREVENTION"] = "PREVENTION";
})(TermsOfUseFlavour || (TermsOfUseFlavour = {}));
const FLAVOUR_OF_ROLE = {
    [Role.ADMIN]: TermsOfUseFlavour.OFFICE_USER,
    [Role.THERAPIST]: TermsOfUseFlavour.OFFICE_USER,
    [Role.MANAGEMENT]: TermsOfUseFlavour.OFFICE_USER,
    [Role.PATIENT]: TermsOfUseFlavour.PATIENT,
    [Role.PREVENTION]: TermsOfUseFlavour.PREVENTION,
};
/** The flavour a Person of this role accepts; none for roles outside any office. */
export const termsOfUseFlavourOf = (role) => FLAVOUR_OF_ROLE[role] ?? null;
export const TERMS_OF_USE_DOCUMENT = {
    [TermsOfUseFlavour.OFFICE_USER]: LegalDocument.TERMS_OF_USE_OFFICE_USER,
    [TermsOfUseFlavour.PATIENT]: LegalDocument.TERMS_OF_USE_PATIENT,
    [TermsOfUseFlavour.PREVENTION]: LegalDocument.TERMS_OF_USE_PREVENTION,
};
//# sourceMappingURL=terms-of-use-flavour.js.map